import React from 'react';
import Header from '../header/Header';
import Footer from '../footer/Footer';
import { Outlet } from 'react-router-dom';
import './Layout.css'


const Layout = () => {
  return (
    <>
      <Header />
      <div className='layout'>
      <Outlet />
      <Footer />
      </div>
      
    </>
  );
};

export default Layout;